import { Injectable } from '@angular/core';

@Injectable()
export class CheckoutStateService {
  public isCheckoutBtnTriggered: boolean;

  constructor() {
    this.isCheckoutBtnTriggered = false;
  }

  setStateCheckoutBtnTriggered(value) {
    this.isCheckoutBtnTriggered = value;
  }
}
